import z from "zod";

const groupDataSchema = z.object({
    ip: z.string(),
    name: z.string(),
});

export { groupDataSchema };
